import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';
import { useToastStore, type ToastMessage } from '@/hooks/use-toast';

function RenderedToast({ toast, onDismiss }: { toast: ToastMessage; onDismiss: () => void }) {
  const { id, title, description, variant, duration } = toast;
  return (
    <Toast
      key={id}
      {...(variant ? { variant } : {})}
      {...(typeof duration === 'number' ? { duration } : {})}
      onOpenChange={(open) => {
        if (!open) onDismiss();
      }}
    >
      <div className="grid gap-1">
        {title ? <ToastTitle>{title}</ToastTitle> : null}
        {description ? <ToastDescription>{description}</ToastDescription> : null}
      </div>
      <ToastClose />
    </Toast>
  );
}

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  return (
    <ToastProvider>
      {toasts.map((t) => (
        <RenderedToast key={t.id} toast={t} onDismiss={() => dismiss(t.id)} />
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
